// extracted by mini-css-extract-plugin
export default {"container":"styles_container__7RJj5","thanks":"styles_thanks__UI8RY","foot":"styles_foot__ZB-pL","dmath":"styles_dmath__OiT6D","info":"styles_info__tOqIw"};